import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef } from "react";

const CustomTextField = styled(TextField)({
  backgroundColor: "white",
  fontFamily: "gilroy !important",

  "& .MuiInputBase-root ": {
    height: "50px !important",
    padding: "0 10px",
  },

  "& label.Mui-focused": {
    color: "black",
    fontWeight: "500",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#EFEFEF",
    },
  },
});
export const TextInput = forwardRef(
  ({ label, multiline, type, rows, value, height, children, step, presicion, ...props }, ref) => {
    console.log(props)
    return (
      <>
        <CustomTextField
          sx={{
            height: height,
            width: "100%",
          }}
          value={value}
          id="outlined-basic"
          label={label}
          type={type || "text"}
          variant="outlined"
          ref={ref}
          multiline={multiline}
          rows={rows}
          {...props}
          inputProps={{
            step: step || 1,
            min: 0,
            precision: presicion || 1,
          }}
        />
        {children}
      </>
    );
  }
);
